module.exports = __webpack_public_path__ + "static/20-1-265e706e63937db55ec5139ec4125a46.jpg";